import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import { useStylesMenu, useStylesMenuItem, useStylesMask } from './styles';

const DropdownMenu = ({ handleLogout, ...props }) => {
  const classesMenu = useStylesMenu();
  const classesMenuItem = useStylesMenuItem();
  const classesMask = useStylesMask();

  return (
    <Menu
      keepMounted
      {...props}
      classes={classesMenu}
      PopoverClasses={classesMask}
    >
      <MenuItem onClick={handleLogout} classes={classesMenuItem}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </MenuItem>
    </Menu>
  );
};

export default DropdownMenu;
